import { Fragment } from "react";

import type { ChatMessage, LegacyGenerationJob } from "~/entities/chat";

import { DateSeparator } from "./DateSeparator";
import type { MessageDateGroup as MessageDateGroupData } from "./group-messages-by-date";
import { MessageItem } from "./MessageItem";

interface MessageDateGroupProps {
    group: MessageDateGroupData;
    collapsed: boolean;
    onToggle: () => void;
    heroMedia: boolean;
    jobsByMessageId: Record<string, LegacyGenerationJob>;
    onRetry: (message: ChatMessage) => void;
    retryingMessageId?: string | null;
    // Сообщение, чьё медиа грузится приоритетно (нижнее в ленте) — см.
    // VirtualMessageList.
    priorityMessageId?: string | undefined;
}

// Рендер одной date-группы: разделитель + (если не свёрнута) её сообщения.
export function MessageDateGroup({
    group,
    collapsed,
    onToggle,
    heroMedia,
    jobsByMessageId,
    onRetry,
    retryingMessageId,
    priorityMessageId,
}: MessageDateGroupProps) {
    return (
        <Fragment>
            <DateSeparator
                date={group.date}
                collapsed={collapsed}
                messageCount={group.messages.length}
                onToggle={onToggle}
            />
            {!collapsed &&
                group.messages.map((message) => (
                    <MessageItem
                        key={message.id}
                        message={message}
                        heroMedia={heroMedia}
                        job={jobsByMessageId[message.id] ?? null}
                        onRetry={onRetry}
                        isRetrying={retryingMessageId === message.id}
                        isPriorityMedia={message.id === priorityMessageId}
                    />
                ))}
        </Fragment>
    );
}
